import { withLanguagePrefix } from "@gsb-core/react-multilang";

export {
  stripLanguagePrefix,
  withLanguagePrefix,
} from "@gsb-core/react-multilang";

export function protectedRouteLoginPath(
  pathname: string,
  search = "",
  hash = "",
): string {
  return `${withLanguagePrefix("/login", pathname)}?callbackUrl=${encodeURIComponent(pathname + search + hash)}`;
}
